import { combineReducers } from 'redux';

import entitiesReducer from './entities';
import selectedActivityGroupsReducer from './selectedActivityGroups';

export default combineReducers({
  entities: entitiesReducer,
  selectedActivityGroups: selectedActivityGroupsReducer
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js